<ion-header>

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/dashboard"></ion-back-button>
    </ion-buttons>
    <ion-title (click)="devMode()">
      <div translate>MENU.TITLE</div>
    </ion-title>
  </ion-toolbar>

</ion-header>

<ion-content class="ion-padding" no-bounce>

  <ion-list>
    <ion-item button (click)="showBadgesPage()"><div translate>PROFILE.BADGES<ion-badge *ngIf="newBadgeCount" button-end class="badge">{{ newBadgeCount }}</ion-badge></div></ion-item>
    <ng-template [ngIf]="hasContents">
      <ion-item button (click)="showContentsPage()"><div translate>PROFILE.CONTENTS<ion-badge *ngIf="newContentCount" button-end class="badge">{{ newContentCount }}</ion-badge></div></ion-item>
    </ng-template>
    <ion-item button (click)="showSettingsPage()"><div translate>PROFILE.SETTINGS</div></ion-item>
    <ion-item button (click)="showPositionPage()"><div translate>PROFILE.MYPROFILE</div></ion-item>
    <ion-item button (click)="showAccountPage()"><div translate>PROFILE.MYACCOUNT</div></ion-item>
    <ion-item button (click)="showHelpPage()"><div translate>PROFILE.HELP</div></ion-item>
    <ion-item button (click)="showDevOptions()" *ngIf="devOptionsEnabled"><div translate>DEV_OPTIONS.TITLE</div></ion-item>
  </ion-list>

</ion-content>
